import * as Sentry from '@sentry/react';

import { dpConfig } from 'src/config';

export function trace() {
  Sentry.init({
    dsn: `${process.env.SENTRY_DSN}`,
    environment: `${dpConfig.env}`,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate:
      parseFloat(`${process.env.SENTRY_TRACES_SAMPLE_RATE}`) || 0.1,
    tracePropagationTargets: ['localhost', `${dpConfig.http.api}`],
    replaysSessionSampleRate:
      parseFloat(`${process.env.SENTRY_REPLAYS_SAMPLE_RATE}`) || 0.1,
    replaysOnErrorSampleRate:
      parseFloat(`${process.env.SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE}`) || 0.1,
  });
}
